exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-c0bb16a4]{padding:45px;margin:1em}.card.off-the-field[data-v-c0bb16a4]{padding:18px}.acquired[data-v-c0bb16a4]{opacity:.5}.off-the-field.acquired[data-v-c0bb16a4]{opacity:1}.license[data-v-c0bb16a4]{position:relative;top:-40px;left:35px}.uk-text-small[data-v-c0bb16a4]{display:block;width:90px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c0bb16a4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Card.vue
// module id = 47
// module chunks = 0